import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { Actions, ofActionDispatched, Select, Store } from '@ngxs/store';
import { AudienceUserExtended } from 'app/library/audience-user/models/audience-user.extended.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, take, tap } from 'rxjs/operators';
import { FetchAudienceUsers } from '../../actions';
import { AudienceUsersState } from '../../models/audience-users.state';

export class AudienceUserDataSource implements DataSource<AudienceUserExtended> {
    @Select(AudienceUsersState.getFilteredEntities)
    filter$: Observable<AudienceUserExtended>;
    private _data: AudienceUserExtended[];

    private _loadingSubject = new BehaviorSubject<boolean>(false);

    public loading$ = this._loadingSubject.asObservable();

    get data() {
        return this._data;
    }

    constructor(private _filteredUser$: Observable<AudienceUserExtended[]>, private _store: Store, private _action$: Actions) {}

    connect(collectionViewer: CollectionViewer): Observable<AudienceUserExtended[]> {
        return this._filteredUser$.pipe(
            tap((filteredUsers) => {
                if (filteredUsers && filteredUsers.length) {
                }
                this._data = filteredUsers;
            })
        );
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this._loadingSubject.complete();
    }

    loadUsers(audienceId?: string, search?: string, sortBy?: string, sortOrder?: string, pageSize?: number, pageNumber?: number): void {
        this._loadingSubject.next(true);
        this._store.dispatch(
            new FetchAudienceUsers({
                audienceId,
                search,
                sortBy,
                sortOrder,
                pageSize,
                pageNumber: pageNumber,
            })
        );

        this._action$
            .pipe(
                ofActionDispatched(FetchAudienceUsers),
                finalize(() => this._loadingSubject.next(false)),
                take(1)
            )
            .subscribe();
    }
}
